export default __webpack_public_path__ + "static/media/3_ru.45fe8c23.png";